import { render, staticRenderFns } from "./ShopCategorySetting.vue?vue&type=template&id=c22a4e18&scoped=true"
import script from "./ShopCategorySetting.vue?vue&type=script&lang=js"
export * from "./ShopCategorySetting.vue?vue&type=script&lang=js"
import style0 from "./ShopCategorySetting.vue?vue&type=style&index=0&id=c22a4e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a4e18",
  null
  
)

export default component.exports